import 'typed';
import imagesLoaded from 'imagesloaded';
import { isInView } from 'isinview';
import Rellax from 'rellax';
import 'paroller.js';

let lastScrollTop = 0;

export function bodyUtils() {
  let isFirstLoad = true;

  if (isFirstLoad) {
    imagesLoaded.makeJQueryPlugin($);
    // Wait for all images to load
    $('html').imagesLoaded(() => {
      setTimeout(() => {
        $('body').toggleClass('is-animating is-loaded').trigger('loaded');
        isFirstLoad = false;
      }, 500);
    });
  } else {
    $('body').toggleClass('is-animating is-loaded').trigger('loaded');
  }
}

export function rellaxUtils() {
  if ($('.rellax:not(.wp-block-cover)').length)
    new Rellax('.rellax:not(.wp-block-cover)', {
      speed: 2,
    });

  if ($('.rellax.wp-block-cover .wp-block-cover__image-background').length)
    new Rellax('.rellax.wp-block-cover .wp-block-cover__image-background', {
      speed: 1,
    });
}

export function buttonUtils() {
  $('.wp-block-button[class*="is-style-"]:not(.is-style-link) .wp-block-button__link').each(function() {
    $(this).append('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.001 13.2241"><path d="m52.001,7.1123c-.208.001-5.126.0972-6.5137,6.1118l-.9746-.2246c.7584-3.2844,2.511-4.9883,4.1314-5.8872H0v-1h48.6442c-1.6204-.8989-3.3732-2.6032-4.1315-5.8877l.9746-.2246c1.3945,6.0425,6.4619,6.1123,6.5127,6.1123l.001,1Z" stroke-width="0" fill="currentColor" /></svg>');
  });
}

export function navUtils() {
  // For Always Overlay Setting
  const backButtonClass = 'back-button';
  const markerClass = 'prepended-main-item';
  // For Always Overlay Setting Comment Out
  // const backButtonClass = 'back-button lg:hidden';
  // const markerClass = 'prepended-main-item lg:hidden';

  // Prepend the back button and the cloned anchor to each submenu on page load
  $('.has-child').each(function() {
    const $anchor = $(this).children('a');
    const $subMenu = $anchor.siblings('.wp-block-navigation__submenu-container');

    // Prepend the cloned anchor
    if (!$subMenu.find('.' + markerClass).length) {
      const $clonedAnchor = $anchor.clone().wrap('<li class="' + markerClass + ' wp-block-navigation-item wp-block-navigation-link"></li>');
      $subMenu.prepend($clonedAnchor.parent());
    }

    // Prepend the back button
    if (!$subMenu.find('.' + backButtonClass).length) {
      const $backButton = $('<button class="' + backButtonClass + ' text-[20px]"><i class="fa-light fa-chevron-left"></i></button>');
      $subMenu.prepend($backButton);
    }
  });

  // For Always Overlay Setting
  $('.has-child > a').on('click', function(e) {
    e.preventDefault();
    const $toggleButton = $(this).siblings('.wp-block-navigation-submenu__toggle');
    $toggleButton.trigger('click');
  });

  // For Always Overlay Setting Comment out
  // if (window.outerWidth <= 1024) {
  //   $('.has-child > a').on('click', function(e) {
  //     e.preventDefault();
  //     const $toggleButton = $(this).siblings('.wp-block-navigation-submenu__toggle');
  //     $toggleButton.trigger('click');
  //   });
  // }

  // Click event for back button
  $(document).on('click', '.back-button', () => {

    console.log('clicked');

    const $this = $(this);
    const $parentMenu = $this.closest('.wp-block-navigation__submenu-container');
    const $toggleButton = $parentMenu.siblings('.wp-block-navigation-submenu__toggle');

    $toggleButton.trigger('click');
  });

  $(document).on('click', '.wp-block-navigation-item:not(.has-child)', () => {
    $('.wp-block-navigation__responsive-container-close').trigger('click');
  });
}

export function windowScrollUtils() {
  const $body = $('body');
  let st = $(window).scrollTop();
  const scrollThreshold = 20;

  if (st < ( lastScrollTop - scrollThreshold )) {
    $body.removeClass('header-hidden');
    $body.addClass('header-sticky');
  }

  if (st > lastScrollTop) {
    $body.addClass('header-hidden');
    $body.removeClass('header-sticky');
  }

  if (st < 50) {
    $body.addClass('header-top');
    $body.removeClass('header-sticky');
    $body.removeClass('header-hidden');
  }

  if (st > 50) {
    $body.removeClass('header-top');
  }

  lastScrollTop = st;
}
